import{jsxs as u,jsx as s}from"react/jsx-runtime";import a,{css as r}from"styled-components";import f from"../../icons/components/CheckmarkIcon.js";import i from"../../theme.js";import{BodyText as $}from"../../typography/BodyText/index.js";import{BackgroundStyles as k}from"../IconButton.js";import{useNameAndId as v}from"../../hooks/useNameAndId.js";import"../../shared/media-queries.js";import"../../utils/utils.js";import"react";import"../../shared/helpers.js";const y=r`
  width: 24px;
  height: 24px;

  svg {
    width: 15px;
    height: 15px;
  }
`,z=r`
  width: 32px;
  height: 32px;

  svg {
    width: 22px;
    height: 22px;
  }
`,b={regular:y,large:z},D=r`
  cursor: default;
  border: 2px solid ${i.colors.grayscaleToned.light2};
`,S=(e,o)=>r`
  svg {
    opacity: 1;
  }

  :hover {
  }

  background: ${i.colors[e][o]};
  border: 2px solid ${i.colors[e][o]};
`,w=r`
  background: ${i.colors.grayscaleToned.light2};
  z-index: 1;
`,C=r`
  border: 2px solid ${i.colors.error.dark};
`,T=a.div`
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  position: relative;
`,j=a.input.attrs({type:"checkbox"})`
  position: absolute;
  appearance: none;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  z-index: 1;
  ${e=>b[e.boxSize]};

  &:hover,
  &:focus {
    transition: background-color 400ms;
    ${k}
  }
  &:focus-visible {
    outline: revert;
  }
`,B=a.span`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  z-index: 0;

  border: 2px solid ${i.colors.grayscaleToned.dark5};

  ${e=>b[e.size]};

  svg {
    opacity: 0;
    color: ${({theme:e})=>e.colors.common.white};
  }

  ${e=>e.isChecked&&S(e.$color,e.$colorShade)};
  ${e=>e.isDisabled&&D};
  ${e=>e.hasError&&C};
  ${e=>e.isChecked&&e.isDisabled&&w};
`,E=a($)`
  flex: 1;
  cursor: ${({isDisabled:e})=>e?"default":"pointer"};
  user-select: none;
  color: ${({theme:e,isDisabled:o})=>o?e.colors.text.disabled:e.colors.text.dark};
  margin-left: 0.5rem;
`,m=({name:e,isDisabled:o=!1,size:d="regular",checked:l=!1,color:c="secondary",colorShade:n="mainAlt",hasError:h=!1,label:t,...g})=>{const{name:p,id:x}=v("check-box",e);return u(T,{children:[s(j,{...g,type:"checkbox",checked:l,"data-validate":"checked",name:p,id:x,$color:c,$colorShade:n,disabled:o,isDisabled:o,boxSize:d,"aria-label":t?void 0:p,"aria-checked":l,"aria-invalid":h||void 0}),s(B,{size:d,$color:c,$colorShade:n,isChecked:l,isDisabled:o,hasError:h,children:s(f,{})}),t&&s(E,{as:"label",htmlFor:x,isDisabled:o,children:t})]})};export{m as CheckBox,m as default};
